import { Pipe, PipeTransform } from '@angular/core';
import { ISector } from "../../service/resources/airTrip/IGetAirTripQuotes";

@Pipe({
    name: 'getNoDoubleCarrierCode'
})

export class GetNoDoubleCarrierCodePipe implements PipeTransform {
    public transform(sectors: ISector[]): string[] {
        return sectors
            .map((sector: ISector) => sector.carrier.code)
            .reduce((codes: string[], code: string) => {
                return codes.includes(code) ?
                    codes :
                    [
                        ...codes,
                        code
                    ];
            }, []);
    }
}
